var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.appearance.layout === 'small-box')?_c('ui-small-gray-box',{attrs:{"props-data":_vm.uiSmallGrayBoxPropsData}}):_c('ui-call-to-action',{attrs:{"props-data":_vm.uiCallToActionPropsData}})}
var staticRenderFns = []

export { render, staticRenderFns }